import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { ARTICLES } from '../../data/content';

export const ArticleCard = ({ article, delay = 0 }) => (
  <Reveal delay={delay} className="h-full">
    <Link
      to="/resources"
      className="group flex h-full flex-col rounded-3xl border border-line bg-white p-7 shadow-card transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-card-hover"
      data-testid={`article-card-${article.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 40)}`}
    >
      <span className="inline-flex w-fit rounded-full bg-navy/5 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wider text-navy/70 transition-colors group-hover:bg-coral/10 group-hover:text-coral">
        {article.category}
      </span>
      <h3 className="mt-5 font-display text-lg font-semibold leading-snug text-navy">{article.title}</h3>
      <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-600">{article.description}</p>
      <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-coral">
        Read More <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </Link>
  </Reveal>
);

const ResourcesHub = () => (
  <section className="bg-mist py-24 md:py-32" data-testid="resources-hub-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          index="09"
          overline="Knowledge Hub"
          title="Career Knowledge Hub"
          description="Guides, checklists, and practical career knowledge — written for students, parents, and professionals."
        />
        <Reveal delay={0.2}>
          <Link
            to="/resources"
            data-testid="resources-view-all-cta"
            className="group inline-flex items-center gap-2 text-sm font-bold text-coral transition-colors hover:text-coral-deep"
          >
            View All Resources
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {ARTICLES.slice(0, 6).map((a, i) => (
          <ArticleCard key={a.title} article={a} delay={0.06 * i} />
        ))}
      </div>
    </div>
  </section>
);

export default ResourcesHub;
